const comparable = {
  getSsoUrl(id, vendor) {
    return `/comparable/${id}/${vendor}/sso`;
  },
  getResult(vendor, token) {
    return `/comparable/${vendor}/result/${token}`;
  },
  gridData(controlNumber) {
    return `/comparable/${controlNumber}/comp-grid`;
  },
  validateComparables(controlNumber) {
    return `/comparable/${controlNumber}/comp-grid/validate`;
  },
  validateComparablesPhoenix(id) {
    return `/homeowner/cases/${id}/phoenix-validate/comparables`;
  },
};

export default comparable;
